/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Trial_Mode_SuffixInputs */

const en_ccsl_export_trial_mode_suffix = /** @type {(inputs: Ccsl_Export_Trial_Mode_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TRIAL MODE`)
};

const fr_ccsl_export_trial_mode_suffix = /** @type {(inputs: Ccsl_Export_Trial_Mode_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MODE ESSAI`)
};

const de_ccsl_export_trial_mode_suffix = /** @type {(inputs: Ccsl_Export_Trial_Mode_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TESTMODUS`)
};

const it_ccsl_export_trial_mode_suffix = /** @type {(inputs: Ccsl_Export_Trial_Mode_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MODALITÀ DI PROVA`)
};

const ru_ccsl_export_trial_mode_suffix = /** @type {(inputs: Ccsl_Export_Trial_Mode_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ПРОБНЫЙ РЕЖИМ`)
};

const es_ccsl_export_trial_mode_suffix = /** @type {(inputs: Ccsl_Export_Trial_Mode_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MODO DE PRUEBA`)
};

const zh_cn2_ccsl_export_trial_mode_suffix = /** @type {(inputs: Ccsl_Export_Trial_Mode_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`试用模式`)
};

const ja_ccsl_export_trial_mode_suffix = /** @type {(inputs: Ccsl_Export_Trial_Mode_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トライアルモード`)
};

const hi_ccsl_export_trial_mode_suffix = /** @type {(inputs: Ccsl_Export_Trial_Mode_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परीक्षण मोड़`)
};

const pt_pt2_ccsl_export_trial_mode_suffix = /** @type {(inputs: Ccsl_Export_Trial_Mode_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MODO DE TESTE`)
};

/**
* | output |
* | --- |
* | "TRIAL MODE" |
*
* @param {Ccsl_Export_Trial_Mode_SuffixInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_trial_mode_suffix = /** @type {((inputs?: Ccsl_Export_Trial_Mode_SuffixInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Trial_Mode_SuffixInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_trial_mode_suffix(inputs)
	if (locale === "de") return de_ccsl_export_trial_mode_suffix(inputs)
	if (locale === "it") return it_ccsl_export_trial_mode_suffix(inputs)
	if (locale === "ru") return ru_ccsl_export_trial_mode_suffix(inputs)
	if (locale === "es") return es_ccsl_export_trial_mode_suffix(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_trial_mode_suffix(inputs)
	if (locale === "ja") return ja_ccsl_export_trial_mode_suffix(inputs)
	if (locale === "hi") return hi_ccsl_export_trial_mode_suffix(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_trial_mode_suffix(inputs)
	return en_ccsl_export_trial_mode_suffix(inputs)
});